import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import close from "images/button-close.svg";

interface Props {
  title: string;
  children: JSX.Element;
  onClose: any;
}

const PopupBottom: React.FunctionComponent<Props> = ({
  title,
  children,
  onClose
}) => {
  useEffect(() => {
    let dimEl: any = document.querySelector("#jsDimBottom");
    disableBodyScroll(dimEl);

    return () => {
      clearAllBodyScrollLocks();
    };
  });

  return (
    <ModalBottom>
      <div onClick={onClose} id="jsDimBottom" className="modalBottomDim" />
      <div className="modalBottomInner">
        <Close>
          <ButtonClose aria-label="팝업 닫기" onClick={onClose} />
        </Close>
        <Header>
          <h4>{title}</h4>
        </Header>
        <Body>{children}</Body>
      </div>
    </ModalBottom>
  );
};

const ModalBottom = styled.div`
  position: fixed;
  z-index: 100;

  .modalBottomDim {
    z-index: 1;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modalBottomInner {
    z-index: 2;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    overflow-y: scroll;
    width: 100%;
    max-height: 100vh;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
    background-color: ${props => props.theme.colors.white};
  }
`;

const Header = styled.header`
  padding: 51px 20px 12px;
  font-size: ${props => props.theme.popupBottom.sizeHeader};
  font-weight: ${props => props.theme.weight.bolder};
  line-height: 1.31;
`;

const Close = styled.span`
  position: absolute;
  top: 12px;
  right: calc(12px + env(safe-area-inset-right));
`;

const ButtonClose = styled.button`
  width: 40px;
  height: 40px;
  background: url(${close}) no-repeat 50% 50%;
  background-size: 13px;
`;

const Body = styled.div`
  padding: 0 20px 80px;
  color: ${props => props.theme.popupBottom.colorFont};
  font-size: ${props => props.theme.text.sizeFont};
  line-height: 1.5;
`;

export default PopupBottom;
